export const getHouseMainCarousel = async (prizeId: number = 1890, version: string = '') =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHouseMainCarousel?prizeId=${prizeId}&version=${version}`);

export const getHousePrizeDetails = async (prizeId: number = 1890, selectedCurrencyCode: string) =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHousePrizeBasicDetails?prizeId=${prizeId}&selectedCurrency=${selectedCurrencyCode}`
  );

export const getHouseMainInformation = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetMainHouseInformation?prizeId=${prizeId}`);

export const getHouseAmeneties = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHouseAmenities?prizeId=${prizeId}`);

export const getHouseMainWidget = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHouseMainWidget?prizeId=${prizeId}`);

export const getPropertySurrounding = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHousePropertySurrounding?prizeId=${prizeId}`);

export const getCoordinates = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHouseCoordinatesData?prizeId=${prizeId}`);

export const getTourCarousels = async (prizeId: number = 1890, version: string = '') =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetPhotoTourCarousel?prizeId=${prizeId}&version=${version}`);

export const getCompetitionEndDate = async () =>
  await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetCompetitionEndDateByUrl?prizeUrl=${location.pathname}`
  );

export const getHouseCompetitionWinners = async () =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetHouseWinners`);

export const getProgressBarData = async (prizeId: number = 1890) =>
  await fetch(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/prizev2/GetTicketCounter?prizeId=${prizeId}`);